module.exports = "/images/london-22.jpg";